import { render } from "./EditCity.vue?vue&type=template&id=c38cfae4&scoped=true"
import script from "./EditCity.vue?vue&type=script&lang=js"
export * from "./EditCity.vue?vue&type=script&lang=js"

import "./EditCity.vue?vue&type=style&index=0&id=c38cfae4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c38cfae4"]])

export default __exports__